import { render } from "./UnderConstruction.vue?vue&type=template&id=1f2f8019&scoped=true"
import script from "./UnderConstruction.vue?vue&type=script&lang=js"
export * from "./UnderConstruction.vue?vue&type=script&lang=js"

import "./UnderConstruction.vue?vue&type=style&index=0&id=1f2f8019&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2f8019"]])

export default __exports__